import React, { useState, useContext, useEffect } from "react";

// import ModalBanner from "../../../ModalBanner";

import { ContextSolicitacoes } from "../../../../services/solicitacoes";

import { ContextoListaApartamentos } from "../../../ApartamentList/contextoImoveis";

import { ContextGetData } from "../../../../services/getData";

import { Spinner } from "../../../StyledComponent";

import { ReactComponent as CancelarSolicitacaoIcon } from "../../../../assets/novosicones/Solicitacoes/CancelarSolicitacao.svg";

import { useHistory } from "react-router-dom";

import "./styles.scss";

import { Button } from "./styles";
import { ContextSindico } from "../../../../services/sindico";

const CancelarSolicitacao = ({
  setShowCancelarSolicitacao,
  caseNumber,
  compromissoServico,
  subgrupo,
  solicitacaoId,
  isSindico,
}) => {
  const { tema } = useContext(ContextoListaApartamentos);

  const [loadingCancelarSolicitacao, setLoadingCancelarSolicitacao] =
    useState(false);

  const [errorMsg, setErrorMsg] = useState("");

  const [classificacao, setClassificacao] = useState("");

  const history = useHistory();

  const { cancelarSolicitacao, getTipoSolicitacoes } = useContext(
    isSindico ? ContextSindico : ContextSolicitacoes
  );

  const { atualizaAgendamentosAbertos } = useContext(ContextGetData);

  function filtraTipoSolicitacao(solicitacoes) {
    return solicitacoes.tipoSalesForce == subgrupo;
  }

  async function getGeraAgendamento() {
    let getTiposDeSolicitacoes = await getTipoSolicitacoes();

    if (subgrupo != undefined && subgrupo != null) {
      let result = await getTiposDeSolicitacoes.filter(filtraTipoSolicitacao);
      if (result.length == 0) {
        setClassificacao("Outros");
      } else {
        setClassificacao(result[0]);
      }
    }
  }

  useEffect(() => {
    (async function () {
      await getGeraAgendamento();
    })();
  }, []);

  function getFullData() {
    if (
      compromissoServico != null &&
      compromissoServico?.earliestStartTime != null
    ) {
      const dataCompromisso = new Date(compromissoServico?.earliestStartTime);

      const data =
        String(dataCompromisso.getDate()).padStart(2, "0") +
        "/" +
        (dataCompromisso.getMonth() + 1 < 10
          ? "0" + (dataCompromisso.getMonth() + 1)
          : dataCompromisso.getMonth() + 1) +
        "/" +
        dataCompromisso.getFullYear() +
        " - " +
        (dataCompromisso.getUTCHours() < 10
          ? "0" + dataCompromisso.getUTCHours()
          : dataCompromisso.getUTCHours()) +
        ":" +
        ((dataCompromisso.getUTCMinutes() < 10 ? "0" : "") +
          dataCompromisso.getUTCMinutes());

      if (classificacao?.tipo == "Assistência Técnica") {
        let periodoDoDia = "";

        if (dataCompromisso.getUTCHours() >= 12) periodoDoDia = "Tarde";
        else periodoDoDia = "Manhã";

        return (
          String(dataCompromisso.getDate()).padStart(2, "0") +
          "/" +
          (dataCompromisso.getMonth() + 1 < 10
            ? "0" + (dataCompromisso.getMonth() + 1)
            : dataCompromisso.getMonth() + 1) +
          "/" +
          dataCompromisso.getFullYear() +
          " - " +
          periodoDoDia
        );
      } else {
        return data;
      }
    }
  }

  getFullData();

  async function cancelSolicitation() {
    setLoadingCancelarSolicitacao(true);

    let resultCancelamentoSolicitacao = await cancelarSolicitacao(
      solicitacaoId,
      classificacao?.geraAgendamento || false
    );
    if (resultCancelamentoSolicitacao) {
      await atualizaAgendamentosAbertos();
      history.push("/solicitacoes");
    } else {
      setErrorMsg(true);
      setLoadingCancelarSolicitacao(false);
    }
  }

  async function cancelSolicitationSindico() {
    setLoadingCancelarSolicitacao(true);

    let resultCancelamentoSolicitacao = await cancelarSolicitacao(
      solicitacaoId,
      classificacao?.geraAgendamento || false
    );
    if (resultCancelamentoSolicitacao) {
      // await atualizaAgendamentosAbertos();
      history.push("/sindico/solicitacoes-abertas/");
    } else {
      setErrorMsg(true);
      setLoadingCancelarSolicitacao(false);
    }
  }

  return (
    <>
      <div
        className="acompanhamentoSolicitacoes__cancelar"
        id="componenteCancelarSolicitacao"
      >
        <div className="centralized-space-between acompanhamentoSolicitacoes__cancelar__headerTitle">
          <span>Cancelamento:</span>
          <div className="acompanhamentoSolicitacoes__cancelar__headerTitle__icon centralized">
            <CancelarSolicitacaoIcon />
          </div>
        </div>
        <div
          style={{ textAlign: "center", height: "100%" }}
          // className="centralized-space-evenly"
        >
          {!errorMsg && (
            <div className="centralized-column acompanhamentoSolicitacoes__cancelar__msgCancelamento">
              <p>
                <strong>Atenção!</strong>
              </p>
              <p>
                Ao cancelar sua solicitação, todas as pendências relacionadas a
                ela serão excluídas e não será possível desfazer o processo.
              </p>
              <p>
                Deseja realmente cancelar sua solicitação
                <strong> {caseNumber} </strong>
                {/* {compromissoServico != null &&
                    (classificacao == "Assistência Técnica" ? (
                      <strong>
                        agendada para o dia
                        {" " +
                          getFullData()
                            .replace(" - ", " no período da ")
                            .toLowerCase()}
                      </strong>
                    ) : (
                      <strong>agendada para o dia {getFullData()}</strong>
                    ))} */}
                ?
              </p>
            </div>
          )}
          {/* {loadingCancelarSolicitacao ? (
            <Spinner />
          ) : ( */}
          <div className="centralized-column">
            {errorMsg != "" && (
              <>
                <p>
                  Não foi possível fazer o cancelamento de sua solicitação{" "}
                  {caseNumber}, para mais informações entre em contato com o{" "}
                  <a
                    style={{ color: "#003DA5" }}
                    href="https://api.whatsapp.com/send?phone=553140200400&text=%20Ol%c3%a1%21%20Estou%20com%20problema%20para%20cancelar%20uma%20solicitação%20.&source=&data="
                    target="_blank"
                    rel="noreferrer"
                  >
                    atendimento ao cliente
                  </a>
                  .
                </p>
                <button
                  id="btnNaoCancelarSolicitacao"
                  onClick={() => {
                    setShowCancelarSolicitacao(false);
                  }}
                >
                  OK
                </button>{" "}
              </>
            )}
          </div>
          {/* )} */}
        </div>
      </div>
      {errorMsg == "" && (
        <div className="centralized-space-between cancelarBtnsContainer">
          <Button
            className="centralized"
            id="btnCancelarSolicitacao"
            onClick={() => {
              (async function () {
                isSindico
                  ? await cancelSolicitationSindico()
                  : await cancelSolicitation();
              })();
            }}
            disabled={loadingCancelarSolicitacao}
          >
            {loadingCancelarSolicitacao ? (
              <Spinner />
            ) : (
              "CONFIRMAR CANCELAMENTO"
            )}
          </Button>

          <Button
            className="centralized"
            id="btnNaoCancelarSolicitacao"
            onClick={() => {
              setShowCancelarSolicitacao(false);
            }}
            disabled={loadingCancelarSolicitacao}
            color={tema.primaryColor}
          >
            VOLTAR
          </Button>
        </div>
      )}
    </>
  );
};

export default CancelarSolicitacao;
